
import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_INSTANCES 
    requestInstances: () => async (dispatch, getState) => {    
        dispatch({ type: 'REQUEST_INSTANCES' });
      const headers = { Authorization: `Bearer ${getToken()}` };
      const url = `api/Instances`;
      const responseI = await fetch(url, {headers});
      const instances = await responseI.json();
      if(instances.length > 0){
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/Registers/lastregisters`;
        const response = await fetch(url, {headers});
        if(response.ok){
            await response.json().then( (lastRegisters)=>{
                const lastregisterstoJSON = [];
                lastRegisters.map((lastRegister) => {
                const registers = [];
                lastRegister.registers.map( (registerTag) => {
                    var tagToJSON = `{ "${registerTag.tag}": ${JSON.stringify(registerTag)} }`;
                    registers.push(
                        JSON.parse(tagToJSON)
                    );
                    return registerTag;
                });
                const registerToJSON = `{ "instanceId":${lastRegister.instanceId}, "registers":${JSON.stringify(registers)}}`;
                lastregisterstoJSON.push(
                    JSON.parse(registerToJSON)
                );
                if(instances)
                instances.map( (instance) => {
                    lastregisterstoJSON.map((lastRegister) => {
                        if(instance.id === lastRegister.instanceId){
                            instance.registers = lastRegister.registers;
                        }
                        return lastRegister;
                    });
                    return instance;
                });
                return lastRegister;
            });
        
      });}
      dispatch({ type: 'RECEIVE_INSTANCES', instances });
      }
    },
    // ADD_INSTANCE
    addInstance: (newInstance) => async (dispatch, getState) => {
        const headers = { 'Authorization': `Bearer ${getToken()}`,
                            'Content-Type': 'application/json'     
                        };    
        const url = `api/Instances`;
        const response = await fetch(url, {
            method: 'post',
            body: JSON.stringify(newInstance),
            headers
        });
        const instance = await response.json();
        dispatch({ type: 'ADD_INSTANCE', instance });
    },
    // REMOVE_INSTANCE
    removeInstance: (id) => async (dispatch, getState) => {
        const headers = { Authorization: `Bearer ${getToken()}` };       
        const url = `api/Instances/${id}`;
        const response = await fetch(url, {
            method: 'delete',
            headers
        });
        await response.json();
        dispatch({ type: 'REMOVE_INSTANCE', id });
    },
    // EDIT_INSTANCE
    editInstance: (instance) => async (dispatch, getState) => {
        const headers = { Authorization: `Bearer ${getToken()}`,
                        'Content-Type': 'application/json' };     
        const url = `api/Instances/${instance.id}`;
        const response = await fetch(url, {
            method: 'put',
            body: JSON.stringify(instance),
            headers
        });
        const updates = instance;
        //await response.json();
        dispatch({ type: 'EDIT_INSTANCE', id: instance.id, updates });
    } 
};




// WEBPACK FOOTER //
// ./src/actions/instances.js